import { render, staticRenderFns } from "./FullPageListLayout.vue?vue&type=template&id=62ca7616"
import script from "./FullPageListLayout.vue?vue&type=script&lang=ts"
export * from "./FullPageListLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports